// LobbyContent.js
import React, { useEffect, useState } from "react";
import { socket } from '../../../helpers/global_helper';

import { withTranslation } from "react-i18next";

const TabularResult = (props) => {
    const cellClass = {
        'DT': {
            "D": 'dgr',
            "T": 'tgr',
            "W": 'tie'
        }
    };
    const [result, setResult] = useState([]);
    useEffect(() => {
        socket.on("game_history", (result) => {
            if (result.room_id == props.room_id) {
                if (result.status != 'success') {
                    return;
                }
                let temp = [];
                let maxLen = 0;
                let tempResult = [...result.results.numbers];
                for (let i = 0; i < tempResult.length; i++) {
                    maxLen = Math.max(maxLen, tempResult[i].length);
                }
                let column = 7;
                // maxLen = maxLen - column;
                for (let i = 0; i < tempResult.length; i++) {
                    for (let j = column - 1; j >= 0; j--) {
                        if (!temp[i])
                            temp[i] = [];
                        temp[i][j] = null;
                        if (tempResult[i][maxLen - j - 1]) {
                            temp[i][j] = tempResult[i][maxLen - j - 1];
                            if (tempResult[i][maxLen - j - 1] == '-') {
                                temp[i][j] = null;
                            }
                        }
                    }
                }
                setResult([...temp]);
            }
        });
    }, [result]);

    useEffect(() => {
        socket.emit("game_history", { room_id: props.room_id });
    }, [props.room_id]);

    return (
        <>
            <div className="game_item_detail dragon-tiger">
{/* Show the "dragon-tiger-table" css to all game_code */}
                {/* <div className="dragon-tiger-table">
                    {result.length > 0 && result.map((obj, i) => {
                        return (
                            <ul className="history_result" key={i}>
                                {obj.length > 0 && obj.map((value, index) => {
                                    return (
                                        <React.Fragment key={index}>
                                            {
                                                !value ?
                                                    <li><div>&nbsp;</div></li>
                                                    : <li><div className={cellClass[props.game_code][value]}>{value == 'D' ? value : "T"}</div></li>
                                            }
                                        </React.Fragment>
                                    )
                                })}
                            </ul>
                        )
                    })}
                </div> */}

{/* // If game.code is "GRH" then hide the "dragon-tiger-table" css which shows the box table  */}
                {props.game_code !== "GRH" && (
                    <div className="dragon-tiger-table">
                        {result.length > 0 && result.map((obj, i) => (
                            <ul className="history_result" key={i}>
                                {obj.length > 0 && obj.map((value, index) => (
                                    <React.Fragment key={index}>
                                        {!value ? (
                                            <li><div>&nbsp;</div></li>
                                        ) : (
                                            <li>
                                                <div className={cellClass[props.game_code][value]}>
                                                    {value === 'D' ? value : "T"}
                                                </div>
                                            </li>
                                        )}
                                    </React.Fragment>
                                ))}
                            </ul>
                        ))}
                    </div>
                )}
            </div>
        </>
    );
}

export default withTranslation()(TabularResult);
